/** Strip non-digits from a CPF input (masked or raw). */
export function normalizeCpf(value: string): string {
  return value.replace(/\D/g, "");
}

function allDigitsSame(digits: string): boolean {
  return /^(\d)\1+$/.test(digits);
}

function checkDigit(base: string, firstWeight: number): number {
  let sum = 0;
  for (let i = 0; i < base.length; i++) {
    sum += Number(base[i]) * (firstWeight - i);
  }
  const rem = sum % 11;
  return rem < 2 ? 0 : 11 - rem;
}

/**
 * Validate a Brazilian CPF (with or without punctuation).
 * Rejects wrong length, all-same-digit sequences, and invalid check digits.
 */
export function isValidCpf(value: string): boolean {
  const digits = normalizeCpf(value);
  if (digits.length !== 11) return false;
  if (allDigitsSame(digits)) return false;

  const d10 = checkDigit(digits.slice(0, 9), 10);
  if (d10 !== Number(digits[9])) return false;

  const d11 = checkDigit(digits.slice(0, 10), 11);
  return d11 === Number(digits[10]);
}

/** Format digits as `000.000.000-00`. Returns empty string if no digits. */
export function formatCpf(value: string): string {
  const digits = normalizeCpf(value).slice(0, 11);
  if (digits.length === 0) return "";

  const p1 = digits.slice(0, 3);
  const p2 = digits.slice(3, 6);
  const p3 = digits.slice(6, 9);
  const p4 = digits.slice(9, 11);

  let out = p1;
  if (p2) out += `.${p2}`;
  if (p3) out += `.${p3}`;
  if (p4) out += `-${p4}`;
  return out;
}

/** Apply mask from raw input (typed or pasted). */
export function maskCpfInput(raw: string): string {
  return formatCpf(raw);
}
